import React from 'react';
import PropTypes from 'prop-types';
import ActionCell from 'App/components/styles/ActionCell';
import { generatePath, Link } from 'react-router-dom';
import { viewEditUserRoute } from 'App/common/routeLookup';

const propTypes = {
    row: PropTypes.shape({
        original: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

const defaultProps = {};

function PendingUserActionsCell({ row }) {
    const user = row.original;
    return (
        <ActionCell>
            <Link to={generatePath(viewEditUserRoute, { userId: user.id })}>Activate</Link>
        </ActionCell>
    );
}

PendingUserActionsCell.propTypes = propTypes;
PendingUserActionsCell.defaultProps = defaultProps;

export default PendingUserActionsCell;
